import React from 'react';

class NavbarLeft extends React.Component {
    render() {
        const {left_links} = this.props
        const {links} = left_links || [];
        let list = []

        if (links)
            links.map((item, index) => {
                item = links[index];
                const {href, text} = item || '';

                list.push(
                    <li key={index}><a href={href}>{text}</a></li>
                )
                return list
            })
            
        return (
            <ul className="nav navbar-nav navbar-left">
                {list}
            </ul>
        )
    }
}

export default NavbarLeft;